export default __webpack_public_path__ + "static/media/finance-gif1.f2872947.gif";